<template>
    <div class="like-button" @click="changeLike">
        <div class="icon" :class="likeIconClass"></div>
        <div class="count" v-if="likeCount">{{ formatCount(likeCount) }}</div>
        <div class="plusOne" ref="plusOne">+1</div>
        <DialogLogin v-if="showDialogLogin" @closeDialogLogin="handleShowDialogLogin" />
    </div>
</template>
<script>
import { getLikeCount, handleLike, handleLikeUnlogin } from '@/js/article-main/request/api';
import Util from '@/utils/util';
import { sendAction } from '@/utils/spmUtil';
import { acodeConfig } from '@/config/spmConfig';
import DialogLogin from '@/components/dialogLogin/dialog-login.vue'
import localStorageUtil from '@/utils/localstorageUtil'
import API from '@/js/api';

export default {
    name: 'LikeButton',
    props: {
        isLogin: {
            type: Boolean,
            default: false,
            required: true,
        },
        articleId: {
            type: String | Number,
            default: '',
            required: true,
        },
    },
    components: {
        DialogLogin,
    },
    data() {
        return {
            isLiked: false,
            likeCount: 0,
            showDialogLogin: false,
        }
    },
    computed: {
        likeIconClass() {
            return this.isLiked ? 'icon-like' : 'icon-unlike'
        },
    },
    created() {
        this.getLikeCount()
    },
    methods: {
        async getLikeCount() {
            try {
                const res = await getLikeCount()
                if (res.code == 1 && res.data) {
                    this.isLiked = res.data.liked
                    this.likeCount = res.data.likeCount
                }
                // 未登录，获取缓存的状态
                if (!this.isLogin) {
                    let articleLiked = localStorageUtil.getItem('articleLiked') || ''
                    if (articleLiked.includes(window.cfgs?.newsId)) {
                        this.isLiked = true
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        changeLike: Util.debounce(async function () {
            sendAction({
                acode: acodeConfig.clickLikeButton,
                clkParam: `s:${+(!this.isLiked)},p:1`
            });
            try {
                // 已登录
                if (this.isLogin) {
                    const res = await handleLike(!this.isLiked)
                    if (res.code == 1) {
                        this.isLiked = !this.isLiked
                        this.likeCount = res.data
                        if (this.isLiked) this.$refs?.plusOne?.classList.add('plusOneDynamic')//增加动效
                        else this.$refs?.plusOne?.classList.remove('plusOneDynamic')//移除动效
                    }
                } else { // 未登录
                    const res = await handleLikeUnlogin(!this.isLiked)
                    if (res.code == 1) {
                        this.isLiked = !this.isLiked
                        this.likeCount = res.data
                        // 记录未登录时的点赞文章
                        let articleLiked = localStorageUtil.getItem('articleLiked')
                        if (this.isLiked) {
                            articleLiked = `${articleLiked}_${window.cfgs?.newsId}` // 增量拼接当前点赞的文章
                            this.$refs?.plusOne?.classList.add('plusOneDynamic') //增加动效
                        } else {
                            articleLiked = articleLiked?.replace(window.cfgs?.newsId, '') // 去除离线存储的对应文章点赞状态
                            this.$refs?.plusOne?.classList.remove('plusOneDynamic') //移除动效
                        }
                        localStorageUtil.setItem('articleLiked', articleLiked)
                        //  每天首次点赞出登录弹窗
                        let isFirstThumb = localStorageUtil.getItem('isFirstThumb')
                        if (!isFirstThumb && this.isLiked && !this.isLogin) {
                            // 展示登录弹窗
                            this.handleShowDialogLogin(true)
                            // 第二天消失
                            var currentTime = new Date().getTime();
                            var targetTime = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)).getTime()// 设置目标时间为今天晚上12点
                            var remainingMilliseconds = targetTime - currentTime // 计算剩余毫秒数
                            localStorageUtil.setItem('isFirstThumb', remainingMilliseconds)
                        }

                    }else{
                        API.call('toast',{
                            text: res.msg,
                            type:-1
                        })
                    }
                }
            } catch (error) {
                console.log('修改点赞状态失败', error)
            }
        }, 200),
        // 格式化点赞数
        formatCount(count) {
            let num = "";
            if (999 > count > 0) {
                num = count;
            } else if (count > 999) {
                num = `999+`;
            }
            return num;
        },
        handleShowDialogLogin(status) {
            this.showDialogLogin = status ? true : false
        },
    },
    watch: {
        isLogin:{
            handler: (newValue) => {
                if(newValue){
                    localStorageUtil.removeItem('articleLiked')
                    localStorageUtil.removeItem('isFirstThumb')
                }
            },
            immediate: true
        }
    }
}
</script>
<style lang="less" scoped>
.like-button {
    width: 40px;/*px*/
    height: 40px;/*px*/
    position: relative;
    margin-left: 44px !important;/*px*/
    .icon {
        width: 40px;/*px*/
        height: 40px;/*px*/
        position: absolute;
        right: 0;
        top: 0;
    }

    .icon-like {
        background: url('../../less/images/icon_liked_red.png') no-repeat center;
        background-size: contain;
    }

    .icon-unlike {
        background: url('../../less/images/icon_like_666666.png') no-repeat center !important;
        background-size: contain !important;
    }

    .count {
        position: absolute;
        width: fit-content;
        transform: translate(-40%, -50%);
        height: 26px;
        /*px*/
        line-height: 26px;
        /*px*/
        height: 28px;
        /*px*/
        background: #ffd100;
        border: 2px solid #ffffff;
        /*px*/
        display: flex;
        align-items: center;
        top: 0px;
        left: 32px;
        /* px */
        color: #111111;
        font-size: 24px;/* px */
        padding: 0 10px; /* px */
        text-align: center;
        border-radius: 17px;/* px */
        box-shadow: 0 0 3px 3px #f2f2f2;
        font-weight: 700;
    }

    .plusOne {
        position: absolute;
        width: 26px;
        height: 34px;
        /*px*/
        line-height: 34px;
        /*px*/
        font-size: 24px;
        /*px*/
        font-weight: 500;
        color: #ffb619;
        opacity: 0;
    }

    .plusOneDynamic {
        top: -38px;
        animation: fadeInUp .3s ease-in-out 1;
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            -webkit-transform: translate3d(0, 100%, 0);
            transform: translate3d(0, 100%, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }
}
</style>